
import moment from 'moment'
import initialStateFlight from './initialState'
import { cart } from '@/utils/mapping'

const mutations = {
  clearFlightsState(state) {
    state.flights = []
  },
  setFlightInitial(state) {
    state.flights.push(initialStateFlight())
  },
  setFlights(state, { searchId, results, flightIndex }) {
    const collection = results.map(item => cart.aviaticket(item))

    state.flights[flightIndex].serviceLoaded = true

    state.flights[flightIndex].aviatickets = {
      ...state.flights[flightIndex].aviatickets,
      isLoading: false,
      searchId,
      collection
    }
  },
  updateFlights(state, { results, flightIndex }) {
    state.flights[flightIndex].aviatickets.collection = [
      ...state.flights[flightIndex].aviatickets.collection,
      ...results.map(item => cart.aviaticket(item))
    ]
  },
  updateFlightCurrent(state, { aviaticketId, flightIndex }) {
    const {
      id,
      requestId,
      price
    } = state.flights[flightIndex].aviatickets.collection.find(item => item.id === aviaticketId)

    state.flights[flightIndex].aviatickets.current = {
      ...state.flights[flightIndex].aviatickets.current,
      id,
      requestId,
      price
    }
  },
  setFlightService(state, payload) {
    const {
      id,
      flightIndex,
      results,
      service
    } = payload
    const aviaticket = state.flights[flightIndex].aviatickets.collection
      .find(item => item.id === id)

    aviaticket[service].isLoading = false
    aviaticket[service].collection = results
  },
  setFlightServiceErrors(state, { id, errors, service }) {
    const aviaticket = state.flights.aviatickets.collection.find(item => item.id === id)

    aviaticket[service].isLoading = false
    aviaticket[service].hasError = true
    aviaticket[service].errors = errors
  },
  updateFlightTarrif(state, { aviaticketId, flightIndex, tarrifId }) {
    const {
      id,
      price
    } = state.flights[flightIndex].aviatickets.collection
      .find(aviaticket => aviaticket.id === aviaticketId).tarrifs.collection
      .find(tarrif => tarrif.id === tarrifId)

    state.flights[flightIndex].aviatickets.current = {
      ...state.flights[flightIndex].aviatickets.current,
      id,
      price
    }
  },
  updatePagination(state, { flightIndex, meta }) {
    state.flights[flightIndex].pagination = {
      ...state.flights[flightIndex].pagination,
      ...meta
    }
  },
  updateIsCollectionLoading(state, { flightIndex, status }) {
    state.flights[flightIndex].isCollectionLoading = status
  },
  setFlightQuotasDates(state, payload) {
    state.flights.quotasDates = {
      direction: payload.direction.map(item => moment.unix(item).toDate()),
      reverseDirection: payload.reverseDirection.map(item => moment.unix(item).toDate())
    }
  }
}

export default mutations